export enum SASortType {
  'Monthly Premium' = 'monthlyPremium',
  'Popularity' = 'popularity'
}
